import { EmailSessionModelWithEmailThread } from '@/api/models/emailSession';

export const getLastUserMessage = (email: EmailSessionModelWithEmailThread) =>
  email.last_user_message ?? email.first_user_message ?? email.session.email_body ?? '';

export const getLastAiResponse = (email: EmailSessionModelWithEmailThread) =>
  email.last_ai_message ?? email.first_ai_message ?? '';
